import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Text, Button } from '../../Atoms';
import { COLOR_BUTTON } from '../../Config/Config';
import { apiGetSeuilFacture } from '../../Api/Documents/Documents';

function OrganismDescriptionRenderedSendDocument({ categoryList, category, type, selectedSeuil, onSelectSeuil }) {
  const [resSeuil, setResSeuil] = useState(null);

  // Effet exécuté une seule fois au montage du composant pour récupérer le seuil de facture
  useEffect(() => {
    const fetchSeuil = async () => {
      try {
        const result = await apiGetSeuilFacture();
        setResSeuil(result?.seuil || 150);
      } catch (error) {
        console.error('Erreur lors de la récupération du seuil de facture :', error);
        setResSeuil(150); // Valeur par défaut en cas d'échec de l'appel API
      }
    };

    fetchSeuil();
  }, []);

  // Recherche de la catégorie sélectionnée dans la liste
  const descriptionIndex = categoryList.find((elem) => elem.categoryName === category);

  // Fonction pour décoder du HTML en texte brut
  const htmlDecode = (input) => {
    const e = document.createElement('div');
    e.innerHTML = input;
    return e.childNodes.length > 0 ? e.childNodes[0].nodeValue : '';
  };

  // Fonction de rendu de l'en-tête du document
  const renderHeader = () => {
    if (type && category) {
      return (
        <Text
          text={`${type.name} - ${category}`}
          type="h8"
          className="header-description-document"
        />
      );
    }
    return null;
  };

  if (!descriptionIndex) {
    return <div></div>; // Retourne un div vide si aucune description trouvée
  }

  return (
    <div>
      {renderHeader()}
      {descriptionIndex.info4User && (
        <div
          dangerouslySetInnerHTML={{
            __html: htmlDecode(
              descriptionIndex.info4User.replace(/(font-size:\s*13px;)/g, 'font-size: 16px;')
            )
          }}
        ></div>
      )}
      {descriptionIndex.addressValid && (
        <>
          <div>
            Vous pouvez également nous transmettre ces documents{' '}
            <span className="doc-bold-text">(sans agrafe)</span> par voie postale à l&apos;adresse ci-dessous :{' '}
          </div>
          <div
            style={{ whiteSpace: 'pre-wrap' }}
            dangerouslySetInnerHTML={{ __html: htmlDecode(descriptionIndex.addressValid) }}
          ></div>{' '}
        </>
      )}
      <br />
      {type?.name === 'FACTURE' && (
        <>
          <div>Merci de sélectionner le montant total estimé de la facture</div>
          <div className="mt-20">
            <Button
              text={`Inférieur à ${resSeuil !== null ? ' ' + resSeuil : '150'}€`}
              className={`btn-seuil-doc mr-20 ${selectedSeuil === 1 ? 'btn-seuil-doc-select' : ''}`}
              onClick={() => onSelectSeuil(1)}
              resetHover={true}
              color={COLOR_BUTTON.SALMON}
            />
            <span className="doc-bold-text">ou</span>
            <Button
              text={`Supérieur à ${resSeuil !== null ? ' ' + resSeuil : '150'}€`}
              className={`btn-seuil-doc ml-20 ${selectedSeuil === 2 ? 'btn-seuil-doc-select' : ''}`}
              onClick={() => onSelectSeuil(2)}
              resetHover={true}
              color={COLOR_BUTTON.SALMON}
            />
          </div>
        </>
      )}
    </div>
  );
}

// Définition des types et validation des props
OrganismDescriptionRenderedSendDocument.propTypes = {
  categoryList: PropTypes.arrayOf(
    PropTypes.shape({
      categoryName: PropTypes.string.isRequired,
      info4User: PropTypes.string,
      addressValid: PropTypes.string
    })
  ).isRequired,
  category: PropTypes.string.isRequired,
  type: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  selectedSeuil: PropTypes.number.isRequired,
  onSelectSeuil: PropTypes.func.isRequired
};

export default OrganismDescriptionRenderedSendDocument;
